import { ResponsiveLine } from '@nivo/line'

import { Line } from 'components/Tooltip'

import { settings } from 'styles'

const LineChart = props => (
  <div className='full'>
    <ResponsiveLine
      {...{ ...settings, ...props }}
      yScale={{
        min: 0,
        max: props.max,
        type: 'linear'
      }}
      tooltip={Line}
    />
  </div>
)

export default LineChart
